import React, { useState, useContext, useEffect } from 'react';
import { WebSocketContext } from './WebSocketProvider';
import './ChatConfigModal.css';

const ChatConfigModal = ({ isOpen, onClose, currentThreadId, threads, sessionId }) => {
    const { socketRef, refreshThread } = useContext(WebSocketContext);
    const [unhiddenInterval, setUnhiddenInterval] = useState('86400000'); // Default to 1 day (24 hours)

    // Time interval options in milliseconds
    const intervalOptions = [
        { value: '5000', label: '5 seconds' },
        { value: '30000', label: '30 seconds' },
        { value: '3600000', label: '1 hour' },
        { value: '86400000', label: '1 day' },
        { value: '2170691800', label: '25 days' }
    ];

    // Fetch current thread settings when modal opens
    useEffect(() => {
        if (isOpen && currentThreadId && threads) {
            console.log('ChatConfig: Loading config for thread:', currentThreadId);
            const currentThread = threads.find(thread => thread.id === currentThreadId);
            if (currentThread && currentThread.config) {
                const currentInterval = currentThread.config.unhiddenInterval || 86400000;
                console.log('ChatConfig: Current interval:', currentInterval);
                setUnhiddenInterval(currentInterval.toString());
            } else {
                console.log('ChatConfig: No config found, using default');
                setUnhiddenInterval('86400000');
            }
        }
    }, [isOpen, currentThreadId, threads]);

    const handleIntervalChange = (e) => {
        console.log('ChatConfig: Interval changed to:', e.target.value);
        setUnhiddenInterval(e.target.value);
    };

    const getCurrentIntervalLabel = () => {
        const option = intervalOptions.find(opt => opt.value === unhiddenInterval);
        return option ? option.label : '1 day';
    };

    const handleSave = () => {
        if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
            console.log('ChatConfig: Sending modify_interval request');
            console.log('ChatConfig: ThreadId:', currentThreadId);
            console.log('ChatConfig: New interval:', unhiddenInterval);

            // Send request to modify the interval
            socketRef.current.send(JSON.stringify({
                type: 'modify_interval',
                threadId: currentThreadId,
                unhiddenInterval: parseInt(unhiddenInterval, 10)
            }));

            console.log('ChatConfig: Request sent successfully');

            // Request a thread refresh to apply the new interval immediately
            setTimeout(() => {
                refreshThread(currentThreadId, sessionId);
            }, 500); // Short delay to ensure modify_interval is processed first

            onClose();
        } else {
            console.error('ChatConfig: WebSocket is not connected');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal chat-config-modal" onClick={(e) => e.stopPropagation()}>
                <h3>Chat Configuration</h3>

                <div className="form-group">
                    <label htmlFor="unhidden-interval">Time until auto-hide:</label>
                    <p className="current-value">Current: {getCurrentIntervalLabel()}</p>
                    <select
                        id="unhidden-interval"
                        value={unhiddenInterval}
                        onChange={handleIntervalChange}
                        className="interval-select"
                    >
                        {intervalOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="modal-actions">
                    <button onClick={handleSave} className="save-button">Save</button>
                    <button onClick={onClose} className="cancel-button">Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default ChatConfigModal; 